(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitChars(el) {
    if (!el || el.dataset.split === '1') return;
    const text = el.textContent.trim();
    el.setAttribute('aria-label', text);
    el.innerHTML = [...text]
      .map((ch, i) => {
        if (ch === ' ') return ' ';
        return `<span class="om-char" style="--i:${i}">${ch}</span>`;
      })
      .join('');
    el.dataset.split = '1';
  }

  function initParallax(el, section) {
    if (reduce || !el) return;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const rect = section.getBoundingClientRect();
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const y = (progress - 0.5) * 48;
        el.style.transform = `translate(-50%, calc(-50% + ${y.toFixed(1)}px))`;
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initSection(section) {
    const typeEl = section.querySelector('[data-mission-type]');
    if (!reduce) splitChars(typeEl);

    initParallax(section.querySelector('[data-mission-parallax]'), section);

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.classList.add('is-inview');
          section.querySelectorAll('[data-mission-value]').forEach((v) => v.classList.add('is-visible'));
          io.unobserve(section);
        });
      },
      { threshold: 0.22, rootMargin: '0px 0px -10% 0px' }
    );
    io.observe(section);

    // Soft pointer parallax on orbit
    const orbit = section.querySelector('[data-mission-orbit]');
    if (orbit && !reduce) {
      orbit.addEventListener('pointermove', (e) => {
        const rect = orbit.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width - 0.5) * 10;
        const y = ((e.clientY - rect.top) / rect.height - 0.5) * 10;
        orbit.style.transform = `scale(1) translate3d(${x}px, ${y}px, 0)`;
      });
      orbit.addEventListener('pointerleave', () => {
        orbit.style.transform = '';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-our-mission]').forEach(initSection);
  });
})();
